<template>
  <Card header="You are receiving a recurring report">
    <div class="vertical-align">
      <p>{{ text[0] }}</p>
      <p>{{ text[1] }}</p>
      <p>{{ text[2] }}</p>
      <p>{{ text[3] }}</p>
    </div>

    <button class="btn btn-outline-primary" @click="onClick()">
      Edit report preferences
    </button>
    <p>or</p>
    <p class="link link-cancel" @click="onClickLink()">
      Cancel recurring report
    </p>
  </Card>
</template>

<script>
import Card from './index';
import GenerateReport from '../GenerateReport';
import { mapGetters } from 'vuex';
import { getPartialScheduleText } from '../helper.js';
import dayjs from 'dayjs';

export default {
  components: { Card, GenerateReport },
  props: ['data'],
  methods: {
    onClick() {
      this.$emit('onEdit', true);
    },
    onClickLink() {
      this.$emit('onDelete', true);
    }
  },
  computed: {
    ...mapGetters('authStore', ['oidcUser']),
    ...mapGetters('dataStore', ['recurringLastDate', 'selectedASN']),
    text() {
      if (!this.data) return ['', '', ''];
      let lineOne = 'We are sending a report ';
      let lineTwo = this.oidcUser.email;
      const lineThree = `For: origin AS ${this.selectedASN.id}`;
      let lineFour = '';
      if (this.recurringLastDate) {
        lineFour = `The latest report sent: ${dayjs(
          this.recurringLastDate
        ).format('DD/MM/YY')}`;
      }
      lineOne += getPartialScheduleText(this.data);
      lineOne += ' to:';
      return [lineOne, lineTwo, lineThree, lineFour];
    }
  }
};
</script>

<style lang="scss" scoped>
button.btn.btn-outline-primary {
  padding: 0 8px;
}
.link {
  color: #007bbd;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}

.link-cancel {
  color: #b00020;
}

.vertical-align {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
}
</style>
